import { get } from "svelte/store";
import API from "../API/API";
import AuthStore from "../Auth/Store";

const AnalyticsInternal = {};
AnalyticsInternal.init = () => {

};
AnalyticsInternal.isInitialised = () => {
	return false;
};
AnalyticsInternal.set = (data) => {

};
AnalyticsInternal.event = (action, data = null) => {
	if (!AuthStore.helpers.isLoggedIn()) {
		return;
	}

	const useData = {
		event: action,
		data_json: {}
	};

	if (typeof data.category !== "undefined") {
		useData.category = data.category;
	}

	if (typeof data.label !== "undefined" && data.label !== get(AuthStore.forms.login.username)) {
		useData.label = data.label;
	}

	const ignoreKeys = ["event_category", "event_label", "event_action", "action", "label", "category", "username"];
	const keys = Object.keys(data);
	for (let i = 0; i < keys.length; i++) {
		if (ignoreKeys.indexOf(keys[i]) >= 0) {
			continue;
		}
		useData.data_json[keys[i]] = data[keys[i]];
	}

	// console.log("useData", useData);
	API.put("analytics/event", useData)
		.then((result) => {
			// console.log(result);
		})
		.catch((e) => {
			console.error(e);
		});
};
export default AnalyticsInternal;
